@use '@/styles/tokens' as *;

.form {
  width: 100%;
  padding: var(--space-6);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 32px;
}

.titleGroup {
  display: flex;
  align-items: center;
  gap: 12px;
}

.backBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: inherit;
  border-radius: 4px;
  flex-shrink: 0;

  &:hover {
    background: rgb(0 0 0 / 5%);
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}

.title {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

// Pill shape override for header action buttons.
.pill {
  border-radius: 100px !important;
  padding-inline: 20px !important;
}

// Form fields constrained to a readable width, left-aligned.
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 20px;
  max-width: 760px;
}

// Description / full-width fields span both columns.
.full {
  grid-column: 1 / -1;
}

.sectionChip,
.addressChip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  width: fit-content;
  margin-bottom: var(--space-4);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
  background: $color-accent1-300;
  color: $color-accent1-900;
  font-size: 12px;
  font-weight: 400;
}

.addressBlock {
  margin-top: var(--space-6);
}

.trash {
  display: inline-flex;
  align-items: center;
  border: 0;
  background: none;
  cursor: pointer;
  color: $color-error-900;
  padding: 0;
}

// The Addresses section's own server message — an `addresses` array-level rejection such as
// "At least one address is required". Sits beside Add Address, where the fault is; the wording
// also goes up as a toast (ADO 118650). It used to be a banner above the whole form, which said
// what was wrong but never where.
.serverError {
  margin: 0 0 8px;
  color: $color-error-900;
  font-size: 12px;
}

// Matches `<FormField>`'s own `.error` look — rendered here instead because the stripped-character
// hint (ADO 118649) isn't an RHF validation error: the value is already valid by the time it's
// checked, so `fieldState.error` never carries it.
.inlineError {
  margin: var(--space-1) 0 0;
  font-size: 11px;
  font-weight: 300;
  color: $color-error-900;
}
